import React, { FC } from 'react';
import { PaperClipOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button, Space, Modal, Typography } from '@retail-core/rds';

const { Text } = Typography;

interface IProps {
  visible: boolean;
  errorsCount: number;
  templateName: string;
  onDownload: () => void;
  onReUpload: () => void;
  onCancel: () => void;
}

export const QuantitiesTemplateErrorsModal: FC<IProps> = (props) => {
  const { visible, errorsCount, templateName, onDownload, onReUpload, onCancel } = props;

  // @ts-ignore
  return (
    <Modal
      title="Supplier quantities could not be imported"
      okText="Re-upload quantities sheet"
      cancelText="Close"
      width={640}
      mask={true}
      maskClosable={false}
      visible={visible}
      centered={true}
      onOk={onReUpload}
      onCancel={onCancel}
      wrapClassName="presize-root"
    >
      {/* @ts-ignore */}
      <Space direction="vertical">
        <Text>
          The quantities sheet you uploaded contains {errorsCount} error{errorsCount > 1 ? 's' : ''}, listed in the
          error sheet below. <br />
          Please fix these errors and re-upload the sheet.
        </Text>
        <Button type="link" danger onClick={onDownload} className="quantities-template-errors-link">
          {/* @ts-ignore */}
          <PaperClipOutlined /> {templateName}
        </Button>
        <Button
          danger
          icon={
            // @ts-ignore
            <DownloadOutlined />
          }
          size="small"
          onClick={onDownload}
        >
          Download error sheet
        </Button>
      </Space>
    </Modal>
  );
};
